const e = "Retour", s = "Fermer", o = "jours", r = "h", n = "Email", t = "heures", a = "minutes", i = "aucun", u = "secondes", l = "En cliquant sur ce lien, vous acceptez l'envoi \xE0 des fins commerciales de nos plans et promotions. En conformit\xE9 avec le R\xE8glement G\xE9n\xE9ral sur la Protection des Donn\xE9es (RGPD), nous vous informons que vos donn\xE9es seront incorpor\xE9es dans nos bases de donn\xE9es. Comme client vous pouvez conna\xEEtre et acc\xE9der gratuitement \xE0 vos donn\xE9es personnelles qui se trouvent sous notre contr\xF4le et exercer les droits qui sont les v\xF4tres en qualit\xE9 de titulaire de ces informations en accords avec ce qui est \xE9tabli par le RGPD.", X = "Termes et conditions", c = {
  "(Optional)": "(Optionnel)",
  Back: e,
  Close: s,
  days: o,
  days_abbr: r,
  Email: n,
  "Great! Email successfully sent!": "Parfait ! Email envoy\xE9 avec succ\xE8s !",
  hours: t,
  "Last reservation was XXXXXX hours ago": "Derni\xE8re r\xE9servation \xE9tait il y a XXXXXX heures",
  minutes: a,
  none: i,
  "Only for registered users": "Seulement pour les utilisateurs enregistr\xE9s",
  "Only for specific rates": "Seulement sur certains tarifs",
  "Please, provide a valid e-mail": "Veuillez fournir un e-mail valide",
  seconds: u,
  "Send to booking engine": "Envoyer au moteur de r\xE9servation",
  "Sending search": "Envoi email",
  "Something went wrong. Please, try again later.": "Quelque chose a mal tourn\xE9. Veuillez r\xE9essayer plus tard.",
  "Subject to availability": "Sous r\xE9serve de disponibilit\xE9",
  Terms_default: l,
  Terms_default_label: X,
  "Thank you!": "Nous vous remercions !",
  "There are XXXXXX people looking at this hotel right now": "Il y a XXXXXX personnes qui consultent cet h\xF4tel en ce moment",
  "There has been an error.": "Il y a eu une erreur.",
  "Today's special offer: XXXXXX": "Aujourd'hui offre sp\xE9ciale: XXXXXX",
  "View all XXXXXX perks": "Voir tous les avantages XXXXXX",
  "We have received your form submission correctly": "Nous avons bien re\xE7u votre formulaire.",
  "We will send you an email with your search very soon.": "Nous vous enverrons un e-mail avec votre recherche tr\xE8s bient\xF4t.",
  "Web exclusive": "Exclusivit\xE9 web",
  "XXXXXX people have already booked today": "XXXXXX personnes ont r\xE9serv\xE9 dans cet h\xF4tel aujourd'hui",
  "XXXXXX people have looked at this hotel today": "XXXXXX personnes ont vu cet h\xF4tel aujourd'hui",
  "XXXXXX% discount only today": "Aujourd'hui XXXXXX% de r\xE9duction",
  "You must agree to the Terms & Conditions first": "Vous devez d'abord accepter les conditions g\xE9n\xE9rales de vente",
  "Your email": "Votre e-mail",
  "Your email address has been successfully added to our list.": "Votre adresse email a \xE9t\xE9 ajout\xE9e avec succ\xE8s \xE0 notre liste."
};
export {
  e as Back,
  s as Close,
  n as Email,
  l as Terms_default,
  X as Terms_default_label,
  o as days,
  r as days_abbr,
  c as default,
  t as hours,
  a as minutes,
  i as none,
  u as seconds
};
//# sourceMappingURL=popup-p-components-fr.js.map
